import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { StyledGrid } from '../styles';
import { Button } from '@mui/material';
import GradientCard from 'Core_Components/GradientCard/GradientCard';
import { appInsights } from 'Core_Helpers/AppInsights';
import { selectUserInfo, selectUserMeta } from 'Core_Redux/user';
import { useCoreSelector } from 'Contexts/StoreContext';
import hasPermissions from 'Core_Helpers/authentication/hasPermissions';
import filterUserMetaByTag from 'Core_Pages/MyTools/userMetaHelpers';
import urlcat from 'urlcat';
import { ToolTypes } from 'Core_Pages/MyTools/enumerations/enums';
import { MYTOOLS } from 'Core_Pages/Routes/RoutesConfig';
import { brainBoosters } from 'Assets/img/my-tools-icons';
import { brainBoosterItems } from 'Core_Pages/MyTools/MyToolsPage/MyBrainBoosterTools/config';

function MyBrainBoostersTile() {
  const history = useHistory();
  const intl = useIntl();
  const profile = useCoreSelector(selectUserInfo);
  const userMeta = useCoreSelector(selectUserMeta);

  function onToolClick() {
    appInsights.trackEvent({ name: 'MyTools_BrainBoosters' });
    history.push(urlcat(MYTOOLS, { toolType: 'brain-boosters' }));
  }

  const getLessonTotal = () => {
    return brainBoosterItems.filter(
      (x) => hasPermissions(x.permissions, x.roles, profile) && filterUserMetaByTag(x.contentCategory, userMeta),
    )?.length;
  };

  return (
    <StyledGrid mobile={12} tablet={6}>
      <Button onClick={onToolClick} fullWidth sx={{ padding: '0px' }}>
        <GradientCard
          titleId="home.tools.brain-boosters"
          backgroundColor="#E5FFEB"
          icon={brainBoosters}
          to={urlcat(MYTOOLS, { toolType: 'brain-boosters' })}
          toolType={ToolTypes.BRAINBOOSTERS}
          imageStyle={{ margin: '22px 6px' }}
          label={`${getLessonTotal()} ${intl.formatMessage({ id: 'home.tools.label' })}`}
        />
      </Button>
    </StyledGrid>
  );
}

export default MyBrainBoostersTile;
